module.exports = __webpack_public_path__ + "1c81bc0809010c78816a02b3ee2ded1f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/selfie-stick.png
// module id = 3048
// module chunks = 0